<template>
  <v-app class="oapp">
    <v-navigation-drawer
      v-if="loggedIn && currentUser && !isLoading
        && !this.$router.currentRoute.fullPath.startsWith('/atendimento-tecnico')
        && !this.$router.currentRoute.fullPath.startsWith('/success')"
      :value="drawer"
      class="oapp-drawer"
      :mini-variant="mini && $vuetify.breakpoint.mdAndUp"
      :permanent="$vuetify.breakpoint.mdAndUp"
      app
      overflow
      dark
      @input="$event !== drawer && setDrawer($event)"
    >
      <v-container class="oapp-drawer-profile">
        <v-row v-if="!mini || $vuetify.breakpoint.smAndDown">
          <img
            src="./assets/logo_yellow.png"
            alt="Menu"
          >
        </v-row>
        <v-row
          justify="center"
          class="pt-2"
        >
          <div class="oapp-drawer-profile-avatar">
            <v-avatar size="40">
              <img src="./assets/avatar_default.jpg">
            </v-avatar>
          </div>
        </v-row>
        <template v-if="!mini || $vuetify.breakpoint.smAndDown">
          <v-row style="font-size: small;">
            <center>
              {{ userMenuTitle }}
            </center>
          </v-row>
          <br>
          <v-row
            v-if="currentUser && currentUser.cpfCnpj && currentUser.cpfCnpj.length==11"
            style="font-size: 10px;"
          >
            <center>
              CPF:
              {{ currentUser.cpfCnpj.substring(0,3) }}.
              {{ currentUser.cpfCnpj.substring(3,6) }}.
              {{ currentUser.cpfCnpj.substring(6,9) }}-
              {{ currentUser.cpfCnpj.substring(9,11) }}
            </center>
          </v-row>
          <v-row
            v-else-if="currentUser && currentUser.cpfCnpj && currentUser.cpfCnpj.length>=14"
            class="oapp-drawer-profile-row--small"
            style="font-size: 10px;"
          >
            <center>
              CNPJ:
              {{ currentUser.cpfCnpj.substring(0,2) }}.
              {{ currentUser.cpfCnpj.substring(2,5) }}.
              {{ currentUser.cpfCnpj.substring(5,8) }}/
              {{ currentUser.cpfCnpj.substring(8,12) }}-
              {{ currentUser.cpfCnpj.substring(12,15) }}
            </center>
          </v-row>
          <v-row
            v-else
            class="oapp-drawer-profile-row--small"
            style="font-size: 10px;"
          >
            <center>
              Bem vindo Novamente!
            </center>
          </v-row>
        </template>
      </v-container>
      <v-list dense>
        <v-list-item-group>
          <v-divider />
          <v-list-item
            v-for="menuItem in globalMenu"
            :key="menuItem.title"
            :to="menuItem.to"
          >
            <v-list-item-icon v-if="menuItem.icon">
              <v-icon>{{ menuItem.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider style="margin-top: 15px;" />
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <v-icon
              v-if="mini === false"
              class="drawer-action"
              @click.stop="setMini(!mini)"
            >
              mdi-chevron-left
            </v-icon>
            <v-icon
              v-if="mini === true"
              class="drawer-action"
              @click.stop="setMini(!mini)"
            >
              mdi-chevron-double-right
            </v-icon>
          </template>
          <v-list-item
            v-for="menuItem in userMenu"
            :key="menuItem.title"
            @click="menuItem.to ? $router.push(menuItem.to) : null"
          >
            <v-list-item-icon v-if="menuItem.icon">
              <v-icon>{{ menuItem.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      class="oapp-bar"
      v-if="!this.$router.currentRoute.fullPath.startsWith('/atendimento-tecnico') && !this.$router.currentRoute.fullPath.startsWith('/success')"
    >
      <OrsAppBarPhones/>
      <v-btn
        v-if="$vuetify.breakpoint.smAndDown && this.$router.currentRoute.fullPath != '/login'"
        depressed
        class="oapp-bar-drawer-activator"
        tile
        large
        color="primary"
        @click.stop="setDrawer(!drawer)"
      >
        <img
          src="./assets/logo_yellow.png"
          alt="Menu"
        >
        <v-icon>
          mdi-menu-down
        </v-icon>
      </v-btn>
      <template v-if="currentUser && currentAccount">
        <v-spacer />

        <div style="margin-bottom: -5px; width: 35%; height: 70px">
          <form>
            <div
              class="form-group form-check text-right check-default"
              style="font-size:12px;padding: 0 30px;"
            >
              <label class="form-check-label">Listar contratos inativos</label>
              <input
                id="inativo"
                v-model="inativos"
                type="checkbox"
                style="margin-left:5px"
              >
            </div>
            <div class="form-group">
              <v-autocomplete
                v-model="accountSelected"
                :items="accountsCombo"
                :filter="filterAccount"
                no-data-text="Nenhuma conta encontrada"
                return-object
                single-line
                :item-text="selected"
                dense
                rounded
              >
                <template v-slot:item="data">
                  <v-list-item-content>
                    <v-list-item-title
                      :class="currentAccount.id === data.item.id ? 'primary--text' : ''"
                    >
                      <b><small>{{ data.item.nameFantasy }} - {{ data.item.cpfCnpjOwner }}</small></b>
                    </v-list-item-title>
                    <v-list-item-subtitle
                      :class="currentAccount.id === data.item.id ? 'primary--text' : ''"
                    >
                      <small>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        PRODUTO: {{ data.item.productName.toLowerCase() }}
                        &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                        ENDEREÇO: {{ data.item.identifier.toLowerCase().replace("; ;", "-").replace(";", "-") }}
                      </small>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </div>
          </form>
        </div>

        <v-menu
          offset-y
          max-width="200"
        >
          <template v-slot:activator="{ on }">
            <v-toolbar-title
              class="oapp-menu-title--avatar"
              v-on="on"
            >
              <v-avatar size="40">
                <v-icon>mdi-account-circle</v-icon>
              </v-avatar>
              <v-icon>
                mdi-menu-down
              </v-icon>
            </v-toolbar-title>
          </template>
          <v-list
            dense
            class="oapp-bar-profile"
          >
            <v-list-item @click="$router.push({name: 'Profile'})">
              <v-list-item-icon>
                <v-icon class="oapp-bar-menu-icon">
                  mdi-account
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>Perfil</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logout">
              <v-list-item-icon>
                <v-icon class="oapp-bar-menu-icon">
                  mdi-logout
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>Sair</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-app-bar>

    <OrsEditPassword
      :value="isPasswordDialogOpen"
      persistent
      @change="changeUserPassword"
    />

    <v-content>
      <portal-target name="content-before" />
      <OrsNotifications :notifications="notifications" />
      <router-view />
    </v-content>

    <!-- <v-footer app /> -->
  </v-app>
</template>

<script>
import {
  mapGetters, mapState, mapActions, mapMutations,
} from 'vuex';
import OrsEditPassword from '@/components/OrsEditPassword.vue';
import OrsNotifications from '@/components/OrsNotifications.vue';
import OrsAppBarPhones from '@/components/OrsAppBarPhones.vue';

export default {
  name: 'App',
  components: {
    OrsEditPassword,
    OrsNotifications,
    OrsAppBarPhones,
  },
  data() {
    return {
      inativos: false,
    };
  },
  computed: {
    ...mapState('app', [
      'drawer',
      'mini',
    ]),
    ...mapGetters('app', [
      'globalMenu',
      'userMenu',
    ]),
    ...mapGetters('notify', [
      'notifications',
    ]),
    ...mapGetters('login', [
      'isPasswordDialogOpen',
      'isLoading',
    ]),
    ...mapGetters('session', [
      'loggedIn',
      'accounts',
    ]),
    ...mapState('session', [
      'currentAccount',
      'currentUser',
    ]),

    userMenuTitle() {
      const user = this.currentUser;
      if (!user) return '';
      return (user.name
        || user.login
        || user.email
        || user.cpfCnpj
        || user.id
      );
    },
    accountSelected: {
      get() {
        return this.currentAccount;
      },
      set(account) {
        if (account) {
          this.updateCurrentAccount(account);
        }
      },
    },
    accountsCombo() {
      const value = this.inativos ? 0 : 1;
      return this.accounts.filter((acc) => {
        console.log(acc);
        return acc.isActive === value;
      });
    },
  },
  watch: {
    loggedIn(isLogged) {
      if (isLogged) {
        this.checkUserFirstLogin();
      }
    },
  },
  methods: {
    ...mapMutations('app', [
      'setDrawer',
      'setMini',
    ]),
    ...mapActions('login', [
      'logout',
      'checkUserFirstLogin',
      'changeUserPassword',
    ]),
    ...mapActions('session', [
      'updateCurrentAccount',
    ]),

    changeAccountSelected(account) {
      this.updateCurrentAccount(account);
    },

    selected(currentAccount) {
      return `${currentAccount.nameFantasy} ${currentAccount.cpfCnpjOwner} ${currentAccount.identifier.replace('; ;', '-').replace(';', '-')} ${currentAccount.id}`;
    },

    filterAccount(item, queryText, itemText ) {
      const name = item.nameFantasy ? item.nameFantasy.toLowerCase() : '';
      const cpfCnpjOwner = item.cpfCnpjOwner.toLowerCase();
      const identifier = item.identifier.toLowerCase();
      const searchText = queryText.toLowerCase();
      return name.indexOf(searchText) > -1
          || cpfCnpjOwner.indexOf(searchText) > -1
          || identifier.indexOf(searchText) > -1;
    },
  },
};
</script>
<style lang="stylus" scoped>
.oapp .oapp-drawer {
  padding: 0 16px !important;
  background-color: var(--primary-color-3);
  background-image: url('./assets/drawer_bg.jpg');
  background-repeat: no-repeat;
  background-position: 0% 50%;

  /deep/ {
    .v-list-item-group .v-list-item--active {
      color: var(--primary-color-3) !important;

      &:before {
        background-color: var(--primary-color-4);
        opacity: 1;
        z-index: -1;
      }

      .theme--dark.v-icon {
        color: inherit;
      }
    }
  }

  .drawer-action {
    position: absolute;
    right: -22px;
    margin-top: -13px;
  }

  .oapp-drawer-profile {
    color: var(--primary-color-4);

    .oapp-drawer-profile-row--small {
      padding-left: 32px;
      padding-right: 32px;
      font-size: .8em;
      font-weight: 500;
    }

    .oapp-drawer-profile-avatar {
      position: relative;

      &:after {
        content: ' ';
        display: block;
        position: absolute;
        right: 0;
        bottom: 0;
        width: 10px;
        height: 10px;
        background-color: var(--secondary-color-4);
        border-radius: 100%;
        overflow: hidden;
      }
    }
  }
}

@media screen and (min-width: 1024px) {
  .oapp .oapp-drawer /deep/ .v-navigation-drawer__content {
    overflow: visible; // for arrow icon
    padding-right: 8px !important; // for arrow icon
  }
}


.oapp .oapp-bar {
  background-color: var(--primary-color-4);

  /deep/ > {
    .v-toolbar__content {
      padding-top: 0;
      padding-bottom: 0;
      padding-left: 0;

      > .v-toolbar__title {
          cursor: pointer;
          color: var(--primary-color-3);
      }

      > .v-toolbar__title + img {
        border-radius: 50%;
        border: 1px solid #eee;
      }

      > .v-list.v-sheet.v-sheet--tile.theme--light {
        > div {
            padding:  0;

            > button {
              width:  100%;
              height: 48px;
            }
        }
      }
    }
  }

  .oapp-bar-drawer-activator {
    max-height: 100%;
    margin-right: 8px;
    background-color: var(--primary-color-3) !important;

    /deep/ > .v-btn__content .v-icon {
      color: var(--primary-color-4);
    }
  }

  .oapp-menu-title--accounts {
    color: var(--primary-color-3) !important;
    font-size: 12px;
  }

  .oapp-menu-title--accounts /deep/ .v-avatar {
    border: none;
    box-shadow: none;
  }

  .oapp-menu-title--accounts /deep/ .v-icon {
    color: inherit;
  }

  .oapp-menu-title--avatar {
    margin-left: 12px;
    overflow: initial;
  }

  .oapp-menu-title--avatar /deep/ .v-avatar {
    border: none;
    box-shadow: none;
  }

  .oapp-menu-title--avatar /deep/ .v-icon {
    color: inherit;
  }
}

.oapp-bar-menu-icon {
  color: var(--dash-color-3);
}

.oapp-bar-accounts {
  overflow-y: auto !important;
  font-size: 12px;
}

div[role="menu"] /deep/ .v-list.oapp-bar-profile .v-list-item__title {
  font-size: 12px;
}
#input-37 {
  width: 0px !important;
}


</style>

<style lang="stylus">
  /* App Theme */
  @import('./style/app.css');
</style>
